requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('promotional-code')) {
      customElements.define(
        'promotional-code',
        class PromotionalCode extends HTMLElement {
          constructor() {
            super();

            themeBase.onDOMContentLoadedTrigger(() => {
              this.button = this.querySelector('.promotional-code__button');
              this.button.addEventListener('click', () => this.copy());
            });
          }

          copy() {
            if (this.classList.contains('promotional-code--copied')) return;

            navigator.clipboard.writeText(this.dataset.code);
            this.classList.add('promotional-code--copied');
            setTimeout(() => this.classList.remove('promotional-code--copied'), 2500);
          }
        }
      );
    }
  });
});